import { React, useState, useEffect } from "react";
import "../CSS/TamilLandingpageNew.css";
import { FaWhatsapp, FaCheck, FaGoogle } from "react-icons/fa";
import poster from "../Assets/Images/Tech/Course/landing poster 1.jpg";
import whatsappIcon1 from "../Assets/Images/Tech/Icons/whatsapp.svg"

const TamilLandingpage = () => {

    const [timer, setTimer] = useState(180); 
    const [seatsLeft, setSeatsLeft] = useState(0);

    const whatsappLinks = [
        "https://wa.link/3et8ik"
    ];



    const shuffleArray = (arr) => {
        const shuffled = [...arr];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
    };

    const [queue, setQueue] = useState([]);

    useEffect(() => {
        // Initial shuffle on mount
        setQueue(shuffleArray(whatsappLinks));
    }, []);

    const openWhatsApp = () => {
        if (queue.length === 0) {
            setQueue(shuffleArray(whatsappLinks));
            return;
        }

        const [nextLink, ...rest] = queue;
        window.open(nextLink, "_blank");

        if (rest.length === 0) {
            // Refill queue once all links have been used
            setQueue(shuffleArray(whatsappLinks));
        } else {
            setQueue(rest);
        }
    };


    useEffect(() => {
        // Timer countdown
        const interval = setInterval(() => {
            setTimer(prev => (prev > 0 ? prev - 1 : 0));
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        // Generate a random seat count (simulate fluctuation per page load)
        const randomSeats = Math.floor(Math.random() * 11) + 5; // between 5 and 15
        setSeatsLeft(randomSeats);
    }, []);

    const formatTime = () => {
        const mins = Math.floor(timer / 60);
        const secs = timer % 60;
        return `${mins}:${secs.toString().padStart(2, "0")}`;
    };



    const pointsLeft = [
        "One-on-One Training கிடைக்கும்",
        "உங்களுக்கு ஏற்ற Customized Learning Plan",
        "தினமும் Phone call-ல Speaking Practise இருக்கும்",
        "Friendly & Expert Trainers உங்க கூட இருப்பாங்க",
        "Tamilnadu-இல் உள்ள நம்பிக்கைக்குரிய English Learning platform",
    ];

    
    const pointsRight = [
        "Personal trainer-இன் தனிப்பட்ட கவனத்துடன் English படிக்கலாம்",
        "உங்கள் Level-க்கு ஏற்ற ட்ரைனிங்",
        "இந்த course-இல் சேர வயசு ஒரு தடை இல்லை",
        "Practise-based Learning",
        "எங்கிருந்தும் English Learn பண்ணலாம், மெசேஜ் வழியா task practise and  trainer corrections இருக்கும் ",
    ];

    return (
        <div className="page-wrapper-123">
            <div className="logo-container-tamil-123">
                <a href="/home">
                    <img
                        className="logo-new-123"
                        src="https://infoc-eb658.web.app/assets/images/tech/logo.svg"
                        alt="Logo"
                    />
                </a>
            </div>

            <div className="content-row-123">
                <div className="content-new-tamil-123">
                    <h2>உங்க Phone மூலமா Easy-அ Spoken English கத்துக்கலாம்</h2>

                    <p className="highlighted-text-123">
                        <FaWhatsapp className="whatsapp-icon-123" />
                        <span className="highlight-123">Spoken English</span> Now Made Easy😇
                    </p>

                    <div className="point-container-123">
                        <ul className="bullet-column-123">
                            {pointsLeft.map((point, idx) => (
                                <li key={idx}>
                                    <span className="custom-bullet-123">
                                        <FaCheck />
                                    </span>
                                    {point}
                                </li>
                            ))}
                        </ul>
                        <ul className="bullet-column-123">
                            {pointsRight.map((point, idx) => (
                                <li key={idx}>
                                    <span className="custom-bullet-123">
                                        <FaCheck />
                                    </span>
                                    {point}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Right image and overlay */}
                <div className="image-container-123">
                    <div className="google-review-overlay-123">
                        <FaGoogle className="google-icon-123" />
                        <div className="stars-123">⭐⭐⭐⭐⭐ 4.8</div>
                        <div className="review-count-123">7,000+ Reviews on Google</div>
                    </div>
                    <img src={poster} alt="Promo" className="landing-image-123" />
                    <div className="limited-offer-section-123">
                        <h3>Limited Time Offer!</h3>
                        <p className="timer-text-123">Offer ends in <strong>{formatTime()}</strong></p>
                        <p className="seats-text-123"><strong>Only {seatsLeft} seats remaining!</strong> </p>

                        <div className="tton-now-123">
                            <a className="banner_link_1-123" onClick={openWhatsApp}>
                                <span className="icon_wrapper_1-123">
                                    <img className="whatsup_1-123" src={whatsappIcon1} alt="WhatsApp Icon" />
                                </span>
                                <span className="text_wrapper_1-123">CLICK TO JOIN</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TamilLandingpage;
